import React, { useState, useEffect } from 'react';
import { MapPin } from 'lucide-react';
import emailjs from '@emailjs/browser';
import './ContactSection.css';

const GmailIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M24 5.457v13.909c0 .904-.732 1.636-1.636 1.636h-3.819V11.73L12 16.64l-6.545-4.91v9.273H1.636A1.636 1.636 0 0 1 0 19.366V5.457c0-2.023 2.309-3.178 3.927-1.964L5.455 4.64 12 9.548l6.545-4.91 1.528-1.145C21.69 2.28 24 3.434 24 5.457z" fill="#EA4335"/>
    <path d="M0 5.457c0-2.023 2.309-3.178 3.927-1.964L12 9.548l8.073-6.055C21.69 2.28 24 3.434 24 5.457L12 16.64 0 5.457z" fill="#EA4335"/>
    <path d="M0 5.457v13.909c0 .904.732 1.636 1.636 1.636h3.819V11.73L0 5.457z" fill="#C5221F"/>
    <path d="M24 5.457v13.909a1.636 1.636 0 0 1-1.636 1.636h-3.819V11.73L24 5.457z" fill="#C5221F"/>
    <path d="M5.455 11.73v9.273h13.09V11.73L12 16.64l-6.545-4.91z" fill="#FFFFFF"/>
    <path d="M0 5.457l5.455 6.273L12 9.548l6.545 2.182L24 5.457 12 16.64 0 5.457z" fill="#EA4335" opacity="0"/>
  </svg>
);

const WhatsAppIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z" fill="#25D366"/>
  </svg>
);

const TelegramIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" fill="#2AABEE"/>
  </svg>
);

const LinkedInIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" fill="#0A66C2"/>
  </svg>
);

const ContactSection = ({ isVisible }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [formStatus, setFormStatus] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (process.env.REACT_APP_EMAILJS_PUBLIC_KEY) {
      emailjs.init(process.env.REACT_APP_EMAILJS_PUBLIC_KEY);
    }
  }, []);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!process.env.REACT_APP_EMAILJS_SERVICE_ID) {
      setFormStatus('Email service not configured.');
      return;
    }

    setIsLoading(true);

    try {
      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        {
          from_name: formData.name,
          from_email: formData.email,
          subject: formData.subject,
          message: formData.message,
          to_email: 'ebraheem.sy370@gmail.com'
        }
      );

      setFormStatus('Message sent successfully! I\'ll get back to you soon.');
      setFormData({ name: '', email: '', subject: '', message: '' });

      setTimeout(() => {
        setFormStatus('');
      }, 4000);
    } catch (error) {
      setFormStatus('Failed to send message. Please try again.');
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section id="contact" className="contact-section">
      <div className="contact-container">
        <div className="contact-header">
          <p className="contact-label">Get In Touch</p>
          <h2 className={`contact-title ${isVisible ? 'animate-slide-up' : 'opacity-0'}`}>
            Let's <span className="gradient-text">Connect</span>
          </h2>
          <p className="contact-subtitle">
            I'm always open to discussing new projects, creative ideas, or opportunities to be part of your visions.
          </p>
        </div>

        <div className="contact-cards">
          <a
            href="mailto:ebraheem.sy370@gmail.com"
            className="contact-card glass glass-hover card-3d"
          >
            <div className="contact-card-icon contact-card-icon--gmail">
              <GmailIcon />
            </div>
            <h3 className="contact-card-title">Gmail</h3>
            <p className="contact-card-value">ebraheem.sy370@gmail.com</p>
          </a>

          <a
            href="https://wa.me/963994451620"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-card glass glass-hover card-3d"
          >
            <div className="contact-card-icon contact-card-icon--whatsapp">
              <WhatsAppIcon />
            </div>
            <h3 className="contact-card-title">WhatsApp</h3>
            <p className="contact-card-value">+963 994 451 620</p>
          </a>

          <a
            href="https://t.me/Eb2wan"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-card glass glass-hover card-3d"
          >
            <div className="contact-card-icon contact-card-icon--telegram">
              <TelegramIcon />
            </div>
            <h3 className="contact-card-title">Telegram</h3>
            <p className="contact-card-value">@ebraheemwannous</p>
          </a>

          <a
            href="https://www.linkedin.com/in/ebraheem-wannous"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-card glass glass-hover card-3d"
          >
            <div className="contact-card-icon contact-card-icon--linkedin">
              <LinkedInIcon />
            </div>
            <h3 className="contact-card-title">LinkedIn</h3>
            <p className="contact-card-value">ebraheem-wannous</p>
          </a>

          <div className="contact-card glass glass-hover card-3d">
            <div className="contact-card-icon">
              <MapPin className="contact-icon" />
            </div>
            <h3 className="contact-card-title">Location</h3>
            <p className="contact-card-value">Damascus, Syria</p>
          </div>
        </div>

        <div className={`contact-form-container glass ${isVisible ? 'animate-scale-in delay-200' : 'opacity-0'}`}>
          <div className="contact-form-bg" />
          <form onSubmit={handleSubmit} className="contact-form">
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Name</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  className="form-input"
                  placeholder="Your name"
                />
              </div>
              <div className="form-group">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  className="form-input"
                  placeholder="your@email.com"
                />
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Subject</label>
              <input
                type="text"
                name="subject"
                value={formData.subject}
                onChange={handleInputChange}
                required
                className="form-input"
                placeholder="What's this about?"
              />
            </div>
            <div className="form-group">
              <label className="form-label">Message</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleInputChange}
                required
                rows={5}
                className="form-textarea"
                placeholder="Your message..."
              />
            </div>
            <button type="submit" className="form-submit-btn" disabled={isLoading}>
              {isLoading ? 'Sending...' : 'Send Message'}
            </button>
            {formStatus && (
              <p className={`form-status ${formStatus.includes('successfully') ? 'success' : 'error'}`}>
                {formStatus}
              </p>
            )}
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
